import React, { useEffect, useState } from 'react'
import DrawerWithTitleAndFooter from '../drawer/DrawerWithTitleAndFooter';

const StepperDrawer = ({
    isOpen = false,
    steps = [],
    activeTabIndex = 0,
    refreshStep = 0,
    setRefreshStep = () => { },
    onCloseCb = () => { }
}) => {

    const [activeStepIndex, setActiveStepIndex] = useState(activeTabIndex);

    // to set index at any particular value
    useEffect(() => {
        setActiveStepIndex(refreshStep)
    }, [refreshStep])

    return (
        <DrawerWithTitleAndFooter
            isOpen={isOpen}
            onCloseCb={onCloseCb}
            title={steps[activeStepIndex]?.title}
            backButtonProp={{
                backCb: () => {
                    if (activeStepIndex > 0) {
                        setActiveStepIndex((index) => index - 1)
                        setRefreshStep((index) => index - 1);
                        steps[activeStepIndex]?.prevCb()
                    }
                },
                text: steps[activeStepIndex]?.backButtonText || "",
                disabled: steps[activeStepIndex]?.backButtonDisable || false
            }}
            submitButtonProp={{
                submitCb: () => {
                    if (activeStepIndex < steps.length - 1) {
                        setActiveStepIndex((index) => index + 1)
                        setRefreshStep((index) => index + 1);
                        steps[activeStepIndex]?.submitButtonDisabled ? steps[activeStepIndex]?.submitButtonDisabledInfoCb() : steps[activeStepIndex]?.submitCb()
                    }
                },
                text: steps[activeStepIndex]?.submitButtonText,
                disabled: steps[activeStepIndex]?.submitButtonDisabled || false
            }}
        >
            {steps[activeStepIndex]?.stepBodyComponent}
        </DrawerWithTitleAndFooter>
    )
}

export default StepperDrawer
